export default __webpack_public_path__ + "static/media/header-x2.cc65119a.png";